'use strict';
angular.module('materialResourcePreviewModule', []).controller('materialResourcePreviewCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'trsPrintService',
    'localStorageService',
    'mrApiService',
    'mrService',
    '$timeout',
    function (
        $scope,
        $state,
        modalDialog,
        trsPrintService,
        localStorageService,
        mrApiService,
        mrService,
        $timeout
    ) {
        initStatus();
        initBtnRights();
        initData();


        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.status = {
                resourcestatus: false, // 判断跳转过来的素材得状态，只有为1 处理完成才能下载
                isPics: '', // 判断是否是图集
                resourceType: $state.params.resourcetype,
                mrType: $state.params.mrtype,
                isOpen: true,
            };
            $scope.data = {
                tags: [],
                original: {
                    0: '转载',
                    1: '原创',
                },
                relationId: $state.params.relationid,
                typeFlag: {
                    '0': '图片',
                    '1': '音频',
                    '2': '视频',
                },
                pics: [], // 图集信息
                result: [], // 打印信息
                ind: '0', // 用来获取上一篇下一篇的id位置
                items: [], // 存放获取来的接口
                curItem: {}, // 当前显示信息的项目
            };
            $scope.params = {
                mrType: $state.params.mrtype,
                mainResourceType: $state.params.resourcetype,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.videos = [];
            $scope.checkList = {};
            $scope.headPic = '';
            $scope.downLoadHerf = `./mr/${$scope.params.mrType}/${$scope.params.mainResourceType}/download?relationId=${$scope.data.relationId}`;
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            mrApiService.getMaterialDetail(angular.extend({ relationId: $state.params.relationid }, $scope.params)).then(
                (data) => {
                    if (data.code === '200') {
                        $scope.status.resourcestatus = data.datas[0].resourcestatus;
                        if ($scope.status.resourcestatus !== 1) {
                            modalDialog.alertType('提示', '获取详情数据失败,该素材处于转码中或者审核中', 'warning', false);
                        }
                        $scope.data.items = data.datas;
                        $scope.data.curItem = $scope.data.items[0];
                        setTags(data.datas[0]);
                        $scope.status.isPics = data.summary_info.relationType;
                        $scope.data.pics = [];
                        if ($scope.status.isPics === 1) {
                            let setList = [];
                            $scope.data.items.forEach((item, index) => {
                                let check = false;
                                if (index === 0) {
                                    check = true;
                                }
                                setList.push({
                                    PERPICURL: item.previewurl,
                                    active: check,
                                    APPDESC: item.resourcetitle,
                                });
                            });
                            $scope.data.pics = setList;
                        }
                    } else {
                        modalDialog.alertType('提示', '获取详情数据失败,该素材处于转码中或者审核中', 'error', false);
                    }
                },
                function (data) {
                    modalDialog.alertType('提示', '请求失败', 'error', false);
                }
            );
        }

        /**
         * [setTags 格式化标签列表]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function setTags(item){
            if ($scope.params.mainResourceType === '0') {
                var tags = [];
                if (item.personlabels) {
                    for (var i = 0; i < item.personlabels.length; i++) {
                        if (item.personlabels[i].labelname) {
                            tags.push(item.personlabels[i].labelname);
                        }
                    }
                }
                if (item.placelabels) {
                    for (var j = 0; j < item.placelabels.length; j++) {
                        tags.push(item.placelabels[j].labelname);
                    }
                }
                if (item.eventlabels) {
                    for (var k = 0; k < item.eventlabels.length; k++) {
                        tags.push(item.eventlabels[k].labelname);
                    }
                }
                $scope.data.tags = tags;
            } else {
                if (item.personmark) {
                    $scope.data.tags = $scope.data.tags.concat(item.personmark.split(';'));
                }
                if (item.placemark) {
                    $scope.data.tags = $scope.data.tags.concat(item.placemark.split(';'));
                }
                if (item.eventmark) {
                    $scope.data.tags = $scope.data.tags.concat(item.eventmark.split(';'));
                }
            }
        }

        /**
         * 按钮权限判断
         */

        $scope.hasRights = function (type) {
            if (parseInt($scope.status.resourcestatus) !== 1) {
                return false;
            }
            let mrtype = $scope.status.mrType;
            if (mrtype === 'personal') {
                return $scope.checkList.chakan;
            } else {
                if (mrtype === 'share' || mrtype === 'meizi') {
                    return 'chakan,upload,edit,delete'.indexOf(type) !== -1 && $scope.checkList[type];
                } else if (mrtype === 'edited') {
                    return 'chakan,upload,edit,delete,uploadmeizi'.indexOf(type) !== -1 && $scope.checkList[type];
                } else {
                    return false;
                }
            }
        };

        $scope.switchPic = function(data){
            $scope.data.curItem = $scope.data.items[data];
            setTags($scope.data.curItem);
        };

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return  {[type]}  [return description]
         */
        function initBtnRights() {
            getBtnRights();
        }

        /**
         * [getBtnRights 获取按钮权限]
         *
         * @return  {[type]}  [return description]
         */
        function getBtnRights() {
            mrService.getBtnRights($scope.status.mrType, $scope.status.resourceType).then(function (data) {
                $scope.checkList = data;
            });
        }

        /**
         * [moveToSharedMaterial description]上传至共享素材
         *
         * @return  {[type]}  [return description]
         */
        $scope.moveToSharedMaterial = function () {
            mrApiService.moveToSharedMaterial(angular.extend({ relationIds: $state.params.relationid }, $scope.params)).then(
                (data) => {
                    if (data.code === '200') {
                        modalDialog.alertType('提示', '上传至共享素材成功', 'success', false);
                    } else {
                        modalDialog.alertType('提示', '上传至共享素材失败', 'error', false);
                    }
                },
                (data) => {
                    modalDialog.alertType('提示', '上传至共享素材失败', 'error', false);
                }
            );
        };

        /**
         * [moveToPersonalMaterial description]取到个人素材
         *
         * @return  {[type]}  [return description]
         */
        $scope.moveToPersonalMaterial = function () {
            mrApiService.moveToPersonalMaterial(angular.extend({ relationIds: $state.params.relationid }, $scope.params)).then(
                (data) => {
                    if (data.code === '200') {
                        modalDialog.alertType('提示', '取至个人素材成功', 'success', false);
                    } else {
                        modalDialog.alertType('提示', '取至个人素材失败', 'error', false);
                    }
                },
                (data) => {
                    modalDialog.alertType('提示', '取至个人素材失败', 'error', false);
                }
            );
        };

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} isPrev [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function (isPrev) {
            let relationIds = localStorageService.get('relationIds');
            if (($scope.data.ind > 0 && isPrev === true) || ($scope.data.ind < relationIds.length - 1 && isPrev === false)) {
                isPrev === true ? $scope.data.ind-- : $scope.data.ind++;
                $scope.params.relationId = relationIds[$scope.data.ind];
                $state.params.relationid = relationIds[$scope.data.ind];
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                requestData();
            } else {
                modalDialog.alertType('提示', `没有${isPrev === true ? '上' : '下'}一篇了！`, 'warning', false);
            }
        };

        /**
         * [printBtn description]打印
         *
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function () {
            requestPrintData();
        };

        /**
         * [requestPrintData description]打印详情
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function requestPrintData() {
            mrApiService.getMaterialDetail(angular.extend({ relationId: $state.params.relationid }, $scope.params)).then((data) => {
                $scope.data.result = data.datas;
                $scope.data.result.forEach((item) => {
                    item.DOC_PICTURELIST = []; // 打印所需的数组
                    item.DOC_PICTURELIST.push({
                        PERPICURL: item.previewurl,
                        APPDESC: item.resourcetitle,
                    });
                    item.DOCTYPEID = '2';
                });
                trsPrintService.trsAppPrintDocument($scope.data.result);
                $scope.data.printResult = [];
            });
        }

        /**
         * [downLoad description]下载操作
         *@param   {[type]}  item  [item description]
         * @return  {[type]}  [return description]
         */
        $scope.downLoad = function (item) {
            let lastUrl; // 存放截取的文件后缀名
            // 判断是不是下载图集
            if ($scope.status.isPics === 1) {
                $scope.data.relationId = $state.params.relationid;
                lastUrl = '.zip';
            } else {
                $scope.data.relationId = $state.params.relationid;
                lastUrl = $scope.data.items[0].fmt;
            }
            // 是不是图集展开 下载每一张
            if (item) {
                $scope.data.relationId = item.relationid;
                lastUrl = item.fmt;
            }
            const sendData = angular.copy($scope.params);
            $scope.loadingPromise = mrApiService.downLoadMetrial(angular.extend(sendData, { relationId: $scope.data.relationId })).then((data) => {
                // 解决媒资下载时返回json但接受的是arraybuffer类型数据的问题
                ab2str(data, function(str) {
                    if (str.indexOf('summary_info') !== -1) {
                        let data = JSON.parse(str);
                        if (data.code === '500') {
                            modalDialog.alertType(data.code, '下载出错', 'error', false);
                        }
                    } else {
                        var downLoad = document.createElement('a');
                        var blob = new Blob([data]);
                        downLoad.href = window.URL.createObjectURL(blob);
                        downLoad.download = item ? item.resourcetitle + '.' + lastUrl : $scope.data.items[0].resourcetitle + '.' + lastUrl;
                        downLoad.click();
                        downLoad = null;
                    }
                });
                
            }, (data) => {
                modalDialog.alertType(data.code, '下载出错', 'error', false);
            });
        };

        /**
         * [takeDoc description]取稿操作
         *
         * @return  {[type]}  [return description]
         */
        $scope.takeDoc = function () {
            mrService.takeDoc($scope.data.relationId, $scope.params);
        };

        /**
         * [showAll description]展开收起图集
         *
         * @return  {[type]}  [return description]
         */
        $scope.showAll = function () {
            $scope.status.isOpen = !$scope.status.isOpen;
            document.getElementById('resource_center_wrap_img').scrollTop = 0;
        };

        /**
         * [ab2str 将arraybuffer数据转换为string]
         *
         * @param   {[type]}  u  [u description]
         * @param   {[type]}  f  [f description]
         *
         * @return  {[type]}     [return description]
         */
        function ab2str(u, f) {
            var b = new Blob([u]);
            var r = new FileReader();
            r.readAsText(b, 'utf-8');
            r.onload = function() {
                if (f){
                    f.call(null, r.result);
                } 
            };
        }
    },
]);
